import { useProjectStore } from '@/store/project-store'
import { Coordinates, LogoState, StickerState } from '@/types'
import useIdGenerator from '@/composables/UseIdGenerator'

const { getId } = useIdGenerator()

export default function useImageStates () {
  const projectStore = useProjectStore()

  /**
   * Create a new StickerState instance
   */
  const createStickerState = (url: string, x?: number, y?: number): StickerState => {
    return {
      id: getId(),
      url,
      x,
      y,
      scale: 1
    }
  }

  const addSticker = (stickerUrl: string, coordinates?: Coordinates): void => {
    const stickerState = createStickerState(stickerUrl, coordinates?.x, coordinates?.y)
    projectStore.stickers.push(stickerState)
  }

  const addLogoSticker = (fileUrl: string, filename: string, coordinates?: Coordinates): void => {
    const stickerState = createStickerState(fileUrl, coordinates?.x, coordinates?.y)
    const logoState: LogoState = {
      filename,
      id: stickerState.id,
      scale: stickerState.scale,
      url: stickerState.url,
      x: stickerState.x,
      y: stickerState.y
    }
    projectStore.logoStickers.push(logoState)
  }

  const deleteSticker = (id: number): void => {
    const logoFindIndex = projectStore.logoStickers.findIndex((sticker: StickerState) => sticker.id === id)
    if (logoFindIndex !== -1) {
      projectStore.logoStickers.splice(logoFindIndex, 1)
    }

    const findIndex = projectStore.stickers.findIndex((sticker: StickerState) => sticker.id === id)
    if (findIndex !== -1) {
      projectStore.stickers.splice(findIndex, 1)
    }
  }

  return {
    addSticker,
    addLogoSticker,
    deleteSticker
  }
}
